import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const modalConatinerStyle = css`
  position: relative;
`;

export const footerStyle = css`
  display: flex;
  flex-direction: row-reverse;
  gap: ${theme.spacing(2)};
  margin-top: ${theme.spacing(2)};
  padding: ${theme.spacing(0, 4)};
`;

export const primaryButtonStyle = css`
  padding: ${theme.spacing(1, 2)};
`;
